import './style.scss';
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import ScrollableX from '../../../../../components/ScrollableX';
import Card from '../../../../../components/Card';


interface IParksProps {
    items: any[];
    home?: boolean;
    onClick?: (item: any) => void;
}


const Parks: React.FC<IParksProps> = ({
    items,
    home = false,
    onClick = undefined
}) => {
    const { translate } = useLanguageContext();


    return <Box className='grid-content-section' id='parks'>
        <Typography variant='subtitle1' className='parks-title'>{translate(home ? 'parksTitleHome' : 'parksTitle')}</Typography>
        <Typography variant='subtitle2' className='parks-description'>{translate(home ? 'parksDescriptionHome' : 'parksDescription')}</Typography>

        <Box className='parks-items'>
            <ScrollableX hasContainer={false}>
                {
                    items.map((r, index) => {
                        return <Card 
                            chip={translate(r.type)}
                            image={r.wallpaper}
                            title={r.name}
                            variant='wallpaper'
                            key={index}
                            Icon={r.Icon}
                            className='width-lg'
                            onClick={() => onClick?.(r)}
                        />;
                    })
                }
            </ScrollableX>
        </Box>
    </Box>;
}

export default Parks;